// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3y0SD","list":"PatternAutocomplete_list__2JyXP"};